export default "__VITE_ASSET__70827c29__"